import PropTypes from 'prop-types';

import {
  ClassNameDefaultProps,
  ClassNamePropTypes,
} from '@/common/proptypes/Base/ClassName.protypes';
import {
  WarehouseDefaultProps,
  WarehousePropTypes,
} from '@/common/proptypes/Common/Warehouse/Warehouse.proptypes';
import {
  OrderDefaultProps,
  OrderPropTypes,
} from '@/common/proptypes/Order/Order.proptypes';

export const AsideDefaultProps = {
  ...ClassNameDefaultProps,
  order: { ...OrderDefaultProps },
  warehouse: { ...WarehouseDefaultProps },
};

export const AsidePropTypes = {
  ...ClassNamePropTypes,
  order: PropTypes.shape({ ...OrderPropTypes }),
  warehouse: PropTypes.shape({ ...WarehousePropTypes }),
};
